export default "__VITE_ASSET__jhaxyitg__"